export function LumieMarketingFooter() {
  return (
    <div className="flex flex-wrap items-center justify-between gap-5 text-sm text-[var(--marketing-muted,#667078)]">
      <div>© Lumie Health</div>
      <div>Data where it belongs, with you.</div>
    </div>
  )
}
